module.exports = __webpack_public_path__ + "img/plus.29f206c4.svg";